module.exports = __webpack_public_path__ + "static/media/fly0092.c8b87e6d.webp";